import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_LEGAL_SPU_REQUEST = "GET_LEGAL_SPU_REQUEST";
export const GET_LEGAL_SPU_SUCCESS = "GET_LEGAL_SPU_SUCCESS";
export const GET_LEGAL_SPU_ERROR = "GET_LEGAL_SPU_ERROR";

//* ACTIONS ------------------------------------------------
export const getLegalSPURequest = (payload = {}, callback) => ({
  type: GET_LEGAL_SPU_REQUEST,
  payload,
  callback,
});

export const getLegalSPUSuccess = (data) => ({
  type: GET_LEGAL_SPU_SUCCESS,
  payload: data,
});

export const getLegalSPUError = (error) => ({
  type: GET_LEGAL_SPU_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getLegalSPUServiceRequest = async ({ payrollId, periodId, ...params }) => {
  const options = await withToken({
    method: Methods.GET,
    params,
    headers: { CompanyId: await getUserCompany() },
  });
  return request(`/payrolls/${payrollId}/periods/${periodId}/spu`, options);
};
